/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 * 
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 * 
 */

import React from 'react';
import { createRoot } from 'react-dom/client'; // correct import for React 18
import { BrowserRouter } from "react-router-dom";
import CacheBuster from 'react-cache-buster';
import "@fontsource/poppins";
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import packageJson from '../package.json';

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <CacheBuster
      currentVersion={packageJson.version}
      isEnabled={true}
      isVerboseMode={false}
      metaFileDirectory={process.env.PUBLIC_URL}
    >
      <BrowserRouter
        basename={process.env.REACT_APP_BASENAME}
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <App />
      </BrowserRouter>
    </CacheBuster>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
